import { first } from 'rxjs/operators';
import {
  AfterContentInit,
  AfterViewInit,
  Directive,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

@Directive({
  selector: '[ngEvents]',
  exportAs: 'ngEvents',
  standalone: false,
})
export class NgEventsDirective implements OnInit, OnDestroy, AfterContentInit, AfterViewInit {
  @Output('ngOnInit') onInit = new EventEmitter<void>();
  @Output('ngAfterContentInit') afterContentInit = new EventEmitter<void>();
  @Output('ngAfterViewInit') afterViewInit = new EventEmitter<void>();
  @Output('ngOnDestroy') onDestroy = new EventEmitter<void>();

  @Output('ngAfterInitAsync') afterInitAsync = new EventEmitter<void>();

  constructor(private zone: NgZone) {}

  ngAfterContentInit() {
    this.afterContentInit.emit();
  }

  ngAfterViewInit() {
    this.afterViewInit.emit();
    this.zone.onStable.pipe(first()).subscribe(() => this.afterInitAsync.emit());
  }

  ngOnInit(): void {
    this.onInit.emit();
  }

  ngOnDestroy(): void {
    this.onDestroy.emit();
  }
}
